
import axios from "axios";
import { BASE_URL } from "../../variables";

// Helper to get token from Redux-persist or localStorage
function getAccessToken() {
  // Try Redux-persisted state
  try {
    const persisted = localStorage.getItem("persist:root");
    if (persisted) {
      const root = JSON.parse(persisted);
      if (root.tokens) {
        const tokens = JSON.parse(root.tokens);
        if (tokens.accessToken) return tokens.accessToken;
      }
    }
  } catch (e) {}
  // Fallback: try direct localStorage (if you store it elsewhere)
  return localStorage.getItem("accessToken") || "";
}

export const getAllMeeting = async ({ userEmailid }) => {
  const accessToken = getAccessToken();
  const options = {
    url: `${BASE_URL}/services/data/v56.0/query?q=select id,CreatedDate,NSM_Status__c,ZSM_Status__c, TMM_Status__c, ZSM_Feedback__c, NSM_Feedback__c,TMM_Feedback__c,Actual_Date_of_the_Meet__c,isTMMCreated__c from Dealer_Relationship_Meet__c where User_Email__c='${userEmailid}'`,
    method: "get",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };
  try {
    const response = await axios(options);
    if (response.status === 200) {
      return {
        success: true,
        data: response?.data,
      };
    } else {
      throw Error("Something Went Wrong..!!");
    }
  } catch (err) {
    return {
      success: false,
      msg: "Somthing Went Wrong..!!",
    };
  }
};
